"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@studio/constants");
var _setSourceUploadStatus = _interopRequireDefault(require("./setSourceUploadStatus"));
var _notification = require("../notification");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function onFailedUpload(dispatch, filename) {
  return function () {
    dispatch((0, _setSourceUploadStatus["default"])(filename, _constants.UPLOAD_FAILED));
    return dispatch((0, _notification.showNotification)('Upload Failed', {
      type: 'warning'
    }));
  };
}
var _default = exports["default"] = onFailedUpload;